// Dollars to cents. ONE implementation, because two of them drifted for five years.
//
// The Apple Pay sheet amount used `parseInt(total.toFixed(2) * 100)`. In JavaScript
// "4.35" * 100 is 434.99999999999994, and parseInt truncates it to 434 - so the sheet
// showed a cent less than the cart on 2,292 of the first 50,000 possible totals. The same
// file already carried a hand-rolled workaround for shipping, under a comment reading
// "JS has an issue with certain float numbers", but it was never applied to the total.
//
// Math.round is exact across the range (verified over 200,000 totals in toCents.test.js).
// Whatever computes an amount shown to a customer or sent to Stripe must use this, so the
// sheet, the cart and the charge cannot disagree.
export const toCents = (dollars) => Math.round(Number(dollars) * 100);

export default toCents;
